import React, { PropTypes } from 'react';
import '../../styles/Blocker';

let Blocker = React.createClass({
	propTypes: {
		shouldShow: PropTypes.bool
	},

	render: function() {
		return(<div className={ 'blocker' + (this.props.shouldShow ? '' : ' hide') } />);
	}
});

module.exports = Blocker;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/Blocker.jsx